import { campaignLength as campaignLengthOptions } from "../constants/campaignLength";

export const getCampaignLengthInWeek = value =>
  campaignLengthOptions.find(option => option.value === value).valueInWeek;
